// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 11) return "static/js/297575ff62e6cc565377.bundle.js";
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"42":"b770398a86d2e5b542fe","133":"48977456a0d3bdba3fe5","134":"a2225b3db3aa85749011"}[chunkId] + ".chunk.js";
};